import { ItemMetaView as SharedItemMetaView } from "@repo/shared-components";
import type { Item, Task } from "~/types/api";
import type { StatusGroup, TabWindow } from "../../../task.types";
import { useFieldMutations } from "./meta-table/hooks/use-field-mutations";
import { useTasksInfo } from "./meta-table/hooks/use-task-info";

const apiBaseUrl = import.meta.env.VITE_FS_API_URL;

type Props = {
  items: Item[];
  tasks?: Task[];
  isLoading?: boolean;
  window: TabWindow<StatusGroup>;
};

export const ItemMetaView = ({ items, isLoading = false, window, tasks }: Props) => {
  return (
    <SharedItemMetaView
      items={items}
      tasks={tasks}
      isLoading={isLoading}
      apiBaseUrl={apiBaseUrl}
      windowId={window?.id}
      useFieldMutations={useFieldMutations}
      useTasksInfo={useTasksInfo}
    />
  );
};
